import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Line } from 'rc-progress';
import logo from './images/targetx_green_x.png';
import help from './images/help.svg';
import ReactToolTip from 'react-tooltip';
import '../styles/broad_camp_cust.css';

const toolTipMapping = {
  'numberSent': 'Total number of emails sent.',
  'numberSentStudent': 'Total number of emails sent to students.',
  'numberSentParent': 'Total number of emails sent to parents.',
  'bounceBack': 'Total number of emails that bounced.',
  'bounceBackStudent': 'Total number of emails to students that bounced.',
  'bounceBackParent': 'Total number of emails to parents that bounced.',
  'recieved': 'Total number of emails received.',
  'recievedStudent': 'Total number of emails received by students.',
  'recievedParent': 'Total number of emails received by parents.',
  'viewedHtml': 'Number of distinct contacts that opened the email (HTML version with images - only)',
  'viewedHtmlStudent': 'Number of distinct students that opened the email (HTML version with images - only)',
  'viewedHtmlParent': 'Number of distinct parents that opened the email (HTML version with images - only)',
  'optOut': 'Number of distinct contacts who opted out of future mailings.',
  'optOutStudent': 'Number of distinct students who opted out of future mailings.',
  'optOutParent': 'Number of distinct parents who opted out of future mailings.',
  'interacted': 'Number of distinct contacts who clicked on a link (link tracking must be enabled)',
  'interactedStudent': 'Number of distinct students who clicked on a link (link tracking must be enabled)',
  'interactedParent': 'Number of distinct parents who clicked on a link (link tracking must be enabled)',
  'didNotInteract': 'Number of distinct contacts that did not click on any tracked links',
  'didNotInteractStudent': 'Number of distinct students that did not click on any tracked links',
  'didNotInteractParent': 'Number of distinct parents that did not click on any tracked links',
  'forwardToAFriendBy': 'Number of contacts who forwarded a message via "Forward to Friend"',
  'forwardToAFriendByStudent': 'Number of students who forwarded a message via "Forward to Friend"',
  'forwardToAFriendByParent': 'Number of parents who forwarded a message via "Forward to Friend"',
  'forwardToAFriendTo': 'Number of friends to whom the message was forwarded',
  'forwardToAFriendToStudent': 'Number of friends to whom the message was forwarded',
  'forwardToAFriendToParent': 'Number of friends to whom the message was forwarded',
  'profileUpdateView': 'Number of contacts who went to update their information',
  'profileUpdateViewStudent': 'Number of students who went to update their information',
  'profileUpdateViewParent': 'Number of parents who went to update their information',
  'profileUpdate': 'Number of contacts that updated their profile via "Update My Information"',
  'profileUpdateStudent': 'Number of students that updated their profile via "Update My Information"',
  'profileUpdateParent': 'Number of parents that updated their profile via "Update My Information"',
  'didNotUpdateProfile': 'Number of contacts that did not update their profile via "Update My Information"',
  'didNotUpdateProfileStudent': 'Number of students that did not update their profile via "Update My Information"',
  'didNotUpdateProfileParent': 'Number of parents that did not update their profile via "Update My Information"',
};


class Email_Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: {},
      loading: false,
      update_timestamp: '',
      hide_error: true,
      hide_release: false,
      disable_release: false,
      release_msg_hide: true
    };
  }

  // Life Cycle Methods
  // Mounting operatiions
  componentDidMount(){
    this.get_stats();
  }

  async get_stats() {
    this.setState({loading: true});
    var results = await axios(
      `/email_stats/${this.props.location.search}`
    );
    var time_stamp = new Date(Date.now());
    var formatted_time = time_stamp.toLocaleString();
    if(results.data['error']){
      await this.setState({error:  results.data['error'], loading: false});
    }else{
      await this.setState({result: results.data, loading: false, update_timestamp: formatted_time});
    }
  }

  async release() {
    this.setState({disable_release: true, loading: true});
    const urlParams = new URLSearchParams(this.props.location.search);
    const headers = {
      'session-id': urlParams.get('session_id'),
      'instance': urlParams.get('sf_location'),
      'orgId': urlParams.get('org')
    };
    const config = {
      'headers': headers
    };
    const requestBody = {
      'campaignId': urlParams.get('campaign_id'),
      'broadcastId': urlParams.get('bcast_id')
    };
    const release_result = await axios.post('/release/', requestBody, config);
    this.setState({
      hide_release: true, 
      release_result: release_result, 
      release_msg_hide: false,
      release_msg: 'Release request sent.',
      loading: false
    });
    setTimeout(
      () => {
        this.get_stats();
      }, 5000
    );
  }

  display_toggle = () => {
    const {hide_error} = this.state;
    const toggled_error = !hide_error;
    this.setState({hide_error: toggled_error});
  }

  render(){
    let { 
      result, 
      loading, 
      update_timestamp, 
      disable_release, 
      hide_release, 
      release_msg_hide,
      release_msg
    } = this.state;
    const ErrorMessage = ({error = this.state.error}) =>  (
      <div style={{marginLeft: '4em', paddingTop: '4em', height: '20em', width: '40em'}}>
        <p onClick={() => this.display_toggle()}>If the broadcast has exceeded the expected completion time, please contact TargetX Support.</p>
        <div hidden={this.state.hide_error} style={{margin: 'auto', height: '10em', width: '20em', padding: '5px', borderRadius: '5px', border: '1px solid', overflow: 'scroll', textAlign: 'left'}}>
          <p>
            {error.Stage_Error}
          </p>
        </div>
      </div>
    );
    const InfoMessage = ({info = result.information}) => (
      <span>
        {info} {result.hold_release_available ? 
          <div style={{display: 'inline'}}>
            <button disable={disable_release} hidden={hide_release} onClick={() => this.release()}>Release</button>
            <span hidden={release_msg_hide}> | {release_msg}</span>
          </div> : null}
      </span>
    );
    return(
      <div>
        {loading ?
          <div className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p>Processing Request...</p>
          </div> : this.state.error ? 
            <ErrorMessage /> : 
            <div className="pbsubsection">
              <table className="detailList">
                <tbody>
                  <tr>
                    <td className="eci-col1">Number Sent<a data-tip data-for="numberSent"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="numberSent" type="info" place="right"><p>{toolTipMapping.numberSent}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div id="sent" style={{textAlign:'right'}}>
                        {result.total_count}
                      </div>
                    </td>
                    <td className="eci-col3"></td>
                    <td className="eci-col4">{result.information ? <InfoMessage /> : null}</td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentSent"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentSent" type="info" place="right"><p>{toolTipMapping.numberSentStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.total_count}
                        </div>
                      </td>
                      <td className="eci-col3"></td>
                      <td className="eci-col4"></td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentSent"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentSent" type="info" place="right"><p>{toolTipMapping.numberSentParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.total_count}
                        </div>
                      </td>
                      <td className="eci-col3"></td>
                      <td className="eci-col4"></td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Bounced Back<a data-tip data-for="bounced"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="bounced" type="info" place="right"><p>{toolTipMapping.bounceBack}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div id="bounce"  style={{textAlign:'right'}}>
                        {result.count_bounce}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p"  style={{textAlign:'right'}}>
                        {result.count_bounce_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_bounce_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentBounced"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentBounced" type="info" place="right"><p>{toolTipMapping.bounceBackStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_bounce}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_bounce_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_bounce_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentBounced"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentBounced" type="info" place="right"><p>{toolTipMapping.bounceBackParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_bounce}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_bounce_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_bounce_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Received<a data-tip data-for="received"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="received" type="info" place="right"><p>{toolTipMapping.recieved}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_received}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_received_p}%
                      </div>
                    </td>
                    <td className="eci-col4" style={{textAlign: 'left'}}>
                      <Line
                        percent={result.count_received_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentReceived"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentReceived" type="info" place="right"><p>{toolTipMapping.recievedStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_received}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_received_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_received_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentReceived"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentReceived" type="info" place="right"><p>{toolTipMapping.recievedParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_received}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_received_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_received_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Opt Out<a data-tip data-for="optout"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="optout" type="info" place="right"><p>{toolTipMapping.optOut}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_optout}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_optout_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_optout_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentOptout"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentOptout" type="info" place="right"><p>{toolTipMapping.optOutStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_optout}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_optout_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_optout_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentOptout"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentOptout" type="info" place="right"><p>{toolTipMapping.optOutParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_optout}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_optout_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_optout_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Viewed HTML<a data-tip data-for="viewedHtml"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="viewedHtml" type="info" place="right"><p>{toolTipMapping.viewedHtml}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_html}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_html_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_html_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentHtml"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentHtml" type="info" place="right"><p>{toolTipMapping.viewedHtmlStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_html}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_html_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_html_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentHtml"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentHtml" type="info" place="right"><p>{toolTipMapping.viewedHtmlParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_html}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_html_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_html_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Interacted<a data-tip data-for="interacted"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="interacted" type="info" place="right"><p>{toolTipMapping.interacted}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_interact}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_interact_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_interact_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentInteracted"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentInteracted" type="info" place="right"><p>{toolTipMapping.interactedStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_interact}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_interact_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_interact_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentInteract"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentInteract" type="info" place="right"><p>{toolTipMapping.interactedParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_interact}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_interact_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_interact_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {result.interaction_details === undefined ? null : result.interaction_details.map(( detail, i ) => {
                    return (
                      <tr key={i}>
                        <td className="eci-col1-indent">
                          <a id="clicktoseelist" href={detail['URL']}>{detail['URL'].slice(0, 50)}</a>
                        </td>
                        <td className="eci-col2">
                          <div id="bounce" style={{textAlign:'right'}}>{detail['activity_count']}</div>
                        </td>
                        <td className="eci-col3">
                          <div is="bounce_p" style={{textAlign:'right'}}>
                            {detail['count_p']}%
                          </div>
                        </td>
                        <td className="eci-col4">
                          <Line
                            percent={detail['count_p']}
                            strokeLinecap="square"
                            strokeColor="#336699"
                            style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Did Not Interact<a data-tip data-for="didNotInteract"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="didNotInteract" type="info" place="right"><p>{toolTipMapping.didNotInteract}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_d_interact}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_d_interact_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_d_interact_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentNotInteract"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentNotInteract" type="info" place="right"><p>{toolTipMapping.didNotInteractStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_d_interact}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_d_interact_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_d_interact_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentNotInteract"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentNotInteract" type="info" place="right"><p>{toolTipMapping.didNotInteractParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_d_interact}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_d_interact_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_d_interact_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Profile Update View<a data-tip data-for="profileUpdateView"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="profileUpdateView" type="info" place="right"><p>{toolTipMapping.profileUpdateView}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_profile_view}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_profile_view_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_profile_view_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentProfileUpdateView"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentProfileUpdateView" type="info" place="right"><p>{toolTipMapping.profileUpdateViewStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_profile_view}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_profile_view_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_profile_view_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentProfileUpdateView"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentProfileUpdateView" type="info" place="right"><p>{toolTipMapping.profileUpdateViewParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_profile_view}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_profile_view_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_profile_view_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Profile Update<a data-tip data-for="profileUpdate"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="profileUpdate" type="info" place="right"><p>{toolTipMapping.profileUpdate}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_profile}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_profile_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_profile_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentProfileUpdate"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentProfileUpdate" type="info" place="right"><p>{toolTipMapping.profileUpdateStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_profile}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_profile_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_profile_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentProfileUpdate"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentProfileUpdate" type="info" place="right"><p>{toolTipMapping.profileUpdateParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_profile}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_profile_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_profile_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                  {loading === false && result.parent && result.student ?
                    <tr>
                      <td className="eci-separator" colSpan="4"></td>
                    </tr>
                    : null}
                  <tr>
                    <td className="eci-col1">Did not Update Profile<a data-tip data-for="didNotUpdateProfile"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                      <ReactToolTip id="didNotUpdateProfile" type="info" place="right"><p>{toolTipMapping.didNotUpdateProfile}</p></ReactToolTip>
                    </td>
                    <td className="eci-col2">
                      <div style={{textAlign:'right'}}>
                        {result.count_d_profile}
                      </div>
                    </td>
                    <td className="eci-col3">
                      <div id="bounce_p" style={{textAlign:'right'}}>
                        {result.count_d_profile_p}%
                      </div>
                    </td>
                    <td className="eci-col4">
                      <Line
                        percent={result.count_d_profile_p}
                        strokeLinecap="square"
                        strokeColor="#336699"
                        style={{width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                      />
                    </td>
                  </tr>
                  {loading === false && result.student ?
                    <tr>
                      <td className="eci-col1-indent">Student<a data-tip data-for="studentDidNotUpdateProfile"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="studentDidNotUpdateProfile" type="info" place="right"><p>{toolTipMapping.didNotUpdateProfileStudent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.student.count_d_profile}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.student.count_d_profile_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.student.count_d_profile_p}
                          strokeLinecap="square"
                          strokeColor="#336633"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr> : null}
                  {loading === false && result.parent ?
                    <tr>
                      <td className="eci-col1-indent">Parent<a data-tip data-for="parentDidNotUpdateProfile"><img src={help} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                        <ReactToolTip id="parentDidNotUpdateProfile" type="info" place="right"><p>{toolTipMapping.didNotUpdateProfileParent}</p></ReactToolTip>
                      </td>
                      <td className="eci-col2">
                        <div style={{textAlign: 'right'}}>
                          {result.parent.count_d_profile}
                        </div>
                      </td>
                      <td className="eci-col3">
                        <div id="bounce_p"  style={{textAlign:'right'}}>
                          {result.parent.count_d_profile_p}%
                        </div>
                      </td>
                      <td className="eci-col4">
                        <Line
                          percent={result.parent.count_d_profile_p}
                          strokeLinecap="square"
                          strokeColor="#999933"
                          style={{textAlign:'left', width: '200px', height: '0.9em', borderColor: '#D9D9D9'}}
                        />
                      </td>
                    </tr>
                    : null}
                </tbody>
              </table>
              <div style={{float:'left', paddingLeft: '14px', paddingTop: '20px'}}>
                <span>
                  <strong>Completed at: </strong>
                  {result.completed_at ? new Date(result.completed_at).toLocaleString() : null}  |  <strong>Last Updated at: </strong>
                  {update_timestamp}
                </span>
              </div>
            </div>
        }
      </div>
    );
  }
}

Email_Stats.propTypes = {
  location: PropTypes.object
};

export default Email_Stats;



// WEBPACK FOOTER //
// ./src/client/views/broad_camp_intel.js